import React, { memo } from 'react';
import { AnalyticsProvider } from '@Context/AnalyticsContext';
import AnalyticsDashboard from '@Analytics/AnalyticsDashboard';

const TokenAnalytics: React.FC = memo(() => {
  return (
    <div className="h-full">
      <AnalyticsProvider>
        <div className="p-6">
          <AnalyticsDashboard />
        </div>
      </AnalyticsProvider>
    </div>
  );
});

TokenAnalytics.displayName = 'TokenAnalytics';

export default TokenAnalytics;
